import { config } from '@ibk/shared-config';
export const SWAP_SECURE_CARD_VIEWER_SCRIPT_URL_STAGING = 'https://api.staging.swapcards.com.br/beta_v3/secure-card-viewer/assets/swap.js';
export const SWAP_SECURE_CARD_VIEWER_SCRIPT_URL_PROD = 'https://api.swapcards.com.br/beta_v3/secure-card-viewer/assets/swap.js';
function normalizeEnv(value) {
    return value?.trim().toLowerCase() ?? '';
}
function isProductionApiBaseUrl(apiBaseUrl) {
    const normalizedApi = apiBaseUrl?.toLowerCase() ?? '';
    if (!normalizedApi) {
        return false;
    }
    if (normalizedApi.includes('api-dev.') ||
        normalizedApi.includes('api-qa.') ||
        normalizedApi.includes('localhost') ||
        normalizedApi.includes('127.0.0.1')) {
        return false;
    }
    return normalizedApi.includes('api.thomsonreuters.com');
}
export function resolveSwapSecureCardViewerScriptUrl(datadogEnv = config.datadogEnv, apiBaseUrl = config.apiBaseUrl) {
    const normalizedEnv = normalizeEnv(datadogEnv);
    if (normalizedEnv === 'production' || normalizedEnv === 'prod') {
        return SWAP_SECURE_CARD_VIEWER_SCRIPT_URL_PROD;
    }
    if (!normalizedEnv && isProductionApiBaseUrl(apiBaseUrl)) {
        return SWAP_SECURE_CARD_VIEWER_SCRIPT_URL_PROD;
    }
    return SWAP_SECURE_CARD_VIEWER_SCRIPT_URL_STAGING;
}
